export default __webpack_public_path__ + "static/glance-internal-displacement-1c7f899237e6e4740563a2dff22d9c58.jpg";